'use client';
import React, { useEffect, useState } from 'react';
import ds from '@/styles/ds/ds.module.scss';
import { ModalStatusEnum, useModalStoreActions, useSideNavOpen } from '@/store';
import { WalletTabEnum } from '@/components/Modals/WalletModal/WalletModal';
import { useRouter } from 'next/navigation';

const BuyCryptoButton = () => {
	const sideNavOpen = useSideNavOpen();
	const [isMounted, setIsMounted] = useState(false);
	const { openWalletModal } = useModalStoreActions();
	const router = useRouter();
	useEffect(() => {
		setIsMounted(true);
	}, []);
	if (!sideNavOpen || !isMounted) return null;
	return (
		<div className="flex flex-col gap-4">
			<button
				aria-label="Buy Crypto"
				className={`
${ds.tertiary} h-10 !bg-powder-blue
				font-bold capitalize`}
				onClick={() => {
					openWalletModal(WalletTabEnum.BuyCrypto, router);
				}}
			>
				Buy Crypto
			</button>
			<div
				className="h-[26px] w-full "
				style={{
					backgroundImage: `url('/img/payment_methods.webp')`,
					backgroundSize: 'contain',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			></div>
		</div>
	);
};

export default BuyCryptoButton;
